module.exports = __webpack_public_path__ + "_/images/apps/9e8a4d2a-6f8c-415e-851b-bdfe4c01d5c1/sumome-black-60.png";